module.exports = __webpack_public_path__ + "img/9345a8052e52d9a2691cf4f2c1535d1b.png";